<!-- 征稿函详情页 -->
<template>
  <div class="all">
    <Header :Share="Share" :isShelves="isShelves" />
    <Shelves v-if="isShelves" />
    <div class="content-box" v-else>
      <!-- 顶部 -->
      <div class="top">
        <!-- 标题 -->
        <div v-if="DetailsList.title" class="title">
          {{ DetailsList.title }}
        </div>
        <!-- logo -->
        <div class="logo" @click="jumpBaike()">
          <div v-if="userInfo.headImg" class="left">
            <van-image
              round
              width="50px"
              height="50px"
              fit="cover"
              :src="$global.imgUrl + userInfo.headImg"
            />
          </div>
          <div v-else class="left">
            <img style="width: 50px" src="@/assets/img/login/4.png" alt="" />
          </div>
          <div class="right">
            <div v-if="DetailsList.perName" class="title">
              {{ DetailsList.perName }}
            </div>
            <div v-if="DetailsList.createTime" class="time">
              发布于：{{ times }}
            </div>
          </div>
        </div>
        <!-- 来源 -->
        <div v-if="DetailsList.perName" class="source">来源：{{ DetailsList.perName }}</div>
        <!-- 内容 -->
        <div v-if="DetailsList.content" class="content">
          <!-- <p>各省、自治区、直辖市及新疆生产建设兵团人力资源社会保障厅（局）、新闻出版局，中央和国家机部委、各直属机构人事部门，中央军委政治工作部宣传局，各中央企业人事部门：新闻专业技术人员是我国专业技术人才队伍的重要组成部分，是做好新闻舆论工作的重要力量。为贯彻落实中共中央办公厅、国务院办公厅印发的《关于深化职称制度改革的意见》，现就深化新闻专业技术人员职称制度改革提出指导意见。</p> -->
          <p v-html="DetailsList.content"></p>
        </div>
      </div>
      <div class="bottom">
        <div class="title">最新资讯</div>
        <div class="list">
          <van-list
            v-model="loading"
            :finished="finished"
            :offset="10"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <van-cell
              @click="toDetail(item)"
              v-for="item in wenxian"
              :key="item.id"
            >
              <div>{{ item.title }}</div>
            </van-cell>
          </van-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Shelves from "./components/shelves.vue";
import Header from "@/views/mobileView/detail/components/Header.vue";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Header,
    Shelves,
  },
  data() {
    //这里存放数据
    return {
      loading: false,
      finished: false,
      DetailsList: {},
      wenxian: [],
      pageNo: 1,
      Share: {},
      userInfo: {},
      isShelves: false,
    };
  },
  //监听属性 类似于data概念
  computed: {
    times() {
      return this.$global.transferDay(this.DetailsList.createTime);
    },
  },
  //监控data中的数据变化
  watch: {
    DetailsList() {
      this.getwenxian();
      let Share = {
        title: this.$global.matchReg(this.DetailsList.title) + ' - 中文知识网',
        summary: this.DetailsList.summary,
      };
      this.Share = Share;
    },
  },
  //方法集合
  methods: {
    //跳转百科
    jumpBaike() {
      let out = this.$route.query.out;
      let web = "web";
      out
        ? this.$router.push(
            `/appusesbaike?item=1&id=${this.DetailsList.perId}&app=${web}&out=${out}`
          )
        : this.$router.push(
            `/appusesbaike?item=1&id=${this.DetailsList.perId}&app=${web}`
          );
    },
    onLoad() {
      // this.getwenxian({
      //   pageNo:this.pageNo+=1
      // })
    },
    async getDetail() {
      const resp = await this.$apis.zgqServe.getDetail({
        id: this.$route.query.id,
      });
      if (resp.resultCode === "200") {
        this.DetailsList = resp.data;
        this.getUser()
        this.$global.toShare(this.DetailsList.monographName, this.DetailsList.summary)
      } else if (
        resp.resultCode === "10401002" ||
        resp.resultCode === "10401001"
      ) {
        this.isShelves = true;
      }
    },
    
    // 获取发布者信息
    async getUser(data) {
      const resp = await this.$apis.recomendServe.getAuthor({
        type: 1,
        companyId: this.DetailsList.perId,
      });
      if (resp.resultCode == 200) {
        this.userInfo = resp.content;
      }
    },
    // 获取相似文献
    async getwenxian() {
      // console.log(this.detailsData.data);
      const { data } = await this.$apis.recomendServe.getwenxian({
        companyId: this.DetailsList.perId,
        pageNo: this.pageNo,
        pageSize: 5,
        // title: "专著",
      });
      if (data.list.length <= 5) {
        this.finished = true;
      }
      this.wenxian.push(...data.list);
    },
    // 跳转到详情
    toDetail(item) {
      let out = this.$route.query.out;
      switch (item.articleType) {
        case 5:
          out
            ? this.$router.push(
                `/msgDetails?id=${item.articleId}&type=${item.articleType}&out=${out}`
              )
            : this.$router.push(
                `/msgDetails?id=${item.articleId}&type=${item.articleType}`
              );
          break;
        case 0:
          out
            ? this.$router.push(
                `/thesisDetail?id=${item.articleId}&type=${item.articleType}&out=${out}`
              )
            : this.$router.push(
                `/thesisDetail?id=${item.articleId}&type=${item.articleType}`
              );
          break;
        case 2:
          out
            ? this.$router.push(
                `/concentrationDetails?id=${item.articleId}&type=${item.articleType}&out=${out}`
              )
            : this.$router.push(
                `/concentrationDetails?id=${item.articleId}&type=${item.articleType}`
              );
          break;
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getDetail();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
};
</script>
<style lang='scss' scoped>
::v-deep iframe {
  max-width: 100% !important;
  max-height: 200px !important;
}
::v-deep img {
  max-width: 100% !important;
}
.all {
  background: #e5e5e5;
  .content-box {
    padding-top: 70px;
    .top {
      overflow: hidden;
      padding: 0 16px 26px 16px;
      background-color: #fff;
      .title {
        font-size: 18px;
        font-family: PingFang;
        font-weight: bold;
        color: #303030;
        margin-top: 20px;
      }
      .logo {
        margin-top: 14px;
        display: flex;
        .left {
          margin-right: 10px;
        }
        .right {
          .title {
            padding-top: 4px;
            font-size: 15px;
            font-family: PingFang;
            color: #333333;
            margin-top: 0px;
          }
          .time {
            padding-top: 4px;
            font-size: 10px;
            font-family: PingFang;
            font-weight: 500;
            color: #999999;
          }
        }
      }
      .source {
        margin-top: 14px;
        font-size: 15px;
        font-family: PingFang;
        font-weight: 500;
        color: #333333;
      }
      .content {
        margin-top: 16px;
        font-size: 15px;
        font-family: PingFang;
        font-weight: 500;
        color: #303030;
        &::v-deep img,
        &::v-deep video {
          max-width: 100% !important;
        }
        &::v-deep span {
          white-space: normal !important;
        }
      }
    }
    .bottom {
      padding: 24px 16px 0 16px;
      margin-top: 8px;
      width: 100%;
      // height: 200px;
      background: #fff;
      .title {
        font-size: 18px;
        font-family: PingFang;
        font-weight: bold;
        color: #303030;
      }
      .list {
        .van-cell {
          padding-left: 0 !important;
          padding-right: 0 !important;
          font-size: 16px;
          font-family: PingFang;
          font-weight: 500;
          color: #303030;
          &::after {
            border-bottom: none !important;
          }
          div {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
}
</style>